import React from "react";
import { Container, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fade, Zoom } from "react-reveal";

const Marketplace = () => {
  return (
    <section className="section features-cant-miss">
      <div className="shapes-container overflow-clear">
        <div className="shape shape-circle shape-circle-1">
          <Fade bottom right>
            <div />
          </Fade>
        </div>
        <div className="shape shape-circle shape-circle-2">
          <Fade bottom left delay={300}>
            <div />
          </Fade>
        </div>
        <div className="shape shape-circle shape-circle-3">
          <Fade bottom right delay={400}>
            <div />
          </Fade>
        </div>
        <div className="shape shape-circle shape-circle-4">
          <Fade bottom right delay={600}>
            <div />
          </Fade>
        </div>

        <div className="shape shape-triangle shape-animated">
          <div className="animation--rotating" />
        </div>
      </div>
      <Container>
        <Row className="gap-y">
          <Col md={{ size: 6, order: "last" }}>
            <div className="section-heading">
              <FontAwesomeIcon
                icon={["fas", "trophy"]}
                className="fa-2x text-danger mb-3"
              />
              <h2 className="heading-line">Marketplace</h2>
              <br/>
              <i>(em breve)</i>
            </div>

            <ul className="list-unstyled">
              
              <li className="media flex-column flex-md-row text-center text-md-left">
                <i className="mx-auto mr-md-3 mx-auto mr-md-3 accent pe pe-7s-global pe-3x" />
                <div className="media-body mt-3 mt-md-0">
                  <h5 className="bold mt-0 mb-1">Internet</h5>
                  <p className="m-0">
                  Com a Pedimos a sua empresa poderá vender pela internet, realizamos toda a transação 
                  financeira e exibimos os seus produtos por meio de um aplicativo e/ou site da internet.
                  </p>
                </div>
              </li>

              <li className="media flex-column flex-md-row text-center text-md-left mt-4">
                <i className="mx-auto mr-md-3 mx-auto mr-md-3 accent pe pe-7s-users pe-3x" />
                <div className="media-body mt-3 mt-md-0">
                  <h5 className="bold mt-0 mb-1">Contato direto</h5>
                  <p className="m-0">
                    Através de um chat é possível conversar diretamente com o cliente, isso permite 
                    resolver eventuais problemas na entrega ou dos produtos.
                  </p>
                </div>
              </li>

              <li className="media flex-column flex-md-row text-center text-md-left mt-4">
                <i className="mx-auto mr-md-3 mx-auto mr-md-3 accent pe pe-7s-calculator pe-3x" />
                <div className="media-body mt-3 mt-md-0">
                  <h5 className="bold mt-0 mb-1">Taxas</h5>
                  <p className="m-0">
                  As taxas dos serviços são de acordo com o seu faturamento e tipo da sua empresa, 
                  se ela é MEI, nada mais justo do que pagar menos pelo produto. Vamos crescer juntos?
                  </p>
                </div>
              </li>
              <li className="media flex-column flex-md-row text-center text-md-left mt-4">
                <i className="mx-auto mr-md-3 mx-auto mr-md-3 accent pe pe-7s-graph1 pe-3x" />
                <div className="media-body mt-3 mt-md-0">
                  <h5 className="bold mt-0 mb-1">Relatórios Avançados</h5>
                  <p className="m-0">
                  A emissão de relatórios é simples e muito completo. Destacamos os produtos mais vendidos, 
                  a quantidade de clientes e o principal, o faturamento, podendo ser consultado entre um período.
                  </p>
                </div>
              </li>
            </ul>
          </Col>

          <Col md="6">
            <div className="bubble bubble-left center-x-md">
              <Zoom bottom>
                <figure className="rounded overflow-hidden shadow">
                  <img
                    src={require("assets/img/screens/app/pieces/4.png")}
                    className="img-responsive"
                    alt=""
                  />
                </figure>
              </Zoom>
            </div>

            <figure className="bubble bubble-right rounded overflow-hidden shadow">
              <Fade right>
                <img
                  src={require("assets/img/screens/app/pieces/5.png")}
                  className="img-responsive"
                  alt=""
                />
              </Fade>
            </figure>

            <div className="iphone light">
              <div className="screen shadow-box">
                <img src={require("assets/img/screens/app/6.png")} alt="..." />
              </div>
              <div className="notch" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Marketplace;
